import React from 'react';
import { Mail, Phone, Hash, Globe, Edit2, ShieldAlert } from 'lucide-react';
import './style.css';

/**
 * CRMContactCard Molecule
 * A card optimized for managing a CRM contact's info with quick email/phone links and actions.
 */
function CRMContactCard({
    person,
    renderActions,
}) {
    const name = person.name || 'Sin Nombre';
    const email = person.email;
    const phone = person.phone;
    const identification = person.identification;
    const active = person.active;
    const documentType = person.identificationsId === 6 ? 'NIT' : person.identificationsId === 3 ? 'CC' : 'Doc';

    const initial = (name || '?').charAt(0).toUpperCase();

    // Determine type tags
    const tags = [];
    if (person.client) tags.push({ label: 'Cliente', className: 'tag-client' });
    if (person.provider) tags.push({ label: 'Proveedor', className: 'tag-provider' });
    if (person.other) tags.push({ label: 'Otro', className: 'tag-other' });

    return (
        <div className={`crm-contact-card ${!active ? 'crm-contact-card--inactive' : ''}`}>
            {/* Status Indicator */}
            <div className="crm-card-status-badge">
                <span className={`crm-status-dot ${active ? 'crm-status-dot--active' : 'crm-status-dot--inactive'}`} />
                <span className="crm-status-text">{active ? 'Activo' : 'Inactivo'}</span>
            </div>

            {/* Header: Avatar + Title */}
            <div className="crm-card-header">
                <div className={`crm-card-avatar ${person.provider ? 'crm-avatar-provider' : 'crm-avatar-client'}`}>
                    <span className="crm-card-avatar-initial">{initial}</span>
                </div>
                <div className="crm-card-identity">
                    <h4 className="crm-card-name" title={name}>{name}</h4>
                    <div className="crm-card-tags">
                        {tags.map((tag, i) => (
                            <span key={i} className={`crm-tag ${tag.className}`}>
                                {tag.label}
                            </span>
                        ))}
                    </div>
                </div>
            </div>

            {/* Body: Contact details */}
            <div className="crm-card-body">
                {identification && (
                    <div className="crm-card-detail">
                        <Hash size={14} className="crm-detail-icon" />
                        <span>{documentType}: {identification}</span>
                    </div>
                )}
                {email && (
                    <div className="crm-card-detail">
                        <Mail size={14} className="crm-detail-icon" />
                        <a href={`mailto:${email}`} className="crm-link">{email}</a>
                    </div>
                )}
                {phone && (
                    <div className="crm-card-detail">
                        <Phone size={14} className="crm-detail-icon" />
                        <a href={`tel:${phone}`} className="crm-link">{phone}</a>
                    </div>
                )}
            </div>

            {/* Footer Actions */}
            {renderActions && (
                <div className="crm-card-actions">
                    {renderActions(person)}
                </div>
            )}
        </div>
    );
}

export default CRMContactCard;
